import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import BreadCrumb from 'components_v2/common/BreadCrumb/BreadCrumb';
import CoverLayout from 'components_etimes/common/CoverLayout/CoverLayout';
import ListView from 'components_etimes/common/ListView/ListView';
import SeoWidget from 'components_etimes/common/SeoWidget/SeoWidget';
import EtimesMoreStories from 'components_etimes/common/EtimesMoreStories/EtimesMoreStories';
import s from './VideosListing.scss';
import TrendingSlider from '../../../../components_v2/desktop/TrendingSlider/TrendingSlider';
import RenderAds from '../../../home/components/desktop/RenderAds/RenderAds';
import analyticsWrapper from '../../../../helpers/analytics/analyticsWrapper';
import InViewObserver from '../../../../components/InViewObserver/InViewObserver';
import BannerView from '../../../../components_etimes/common/BannerView/BannerView';

class VideosListing extends React.Component {
  constructor() {
    super();
    this.state = {
      thresholds: [10, 750, 1500, 2250],
      bannerOpacity: 1,
    };
    this.scrollGAElements = [];
    this.handledScrollGAElements = {};
    this.bannerViewRef = React.createRef();
  }

  componentDidMount() {
    this.throttledGAonScroll = throttle(this.handleGAOnScroll, 100);
    this.throttledGAonScroll2 = throttle(this.handleGAOnScroll, 200);
    let initialHeight = 0;
    window.addEventListener('scroll', () => {
      if (this.bannerViewRef.current) {
        const rect = this.bannerViewRef.current.getBoundingClientRect();
        // if (rect.height - window.screenTop < 0) {
        //   return;
        // }
        if (
          rect.top <= 0 &&
          (initialHeight === 0 || initialHeight > window.scrollY)
        ) {
          initialHeight = window.scrollY;
        }
        if (rect.top <= 0) {
          this.setState({
            bannerOpacity:
              1 - Math.abs((initialHeight - window.scrollY) / initialHeight),
          });
        }
      }
    });
    window.addEventListener('scroll', this.throttledGAonScroll2);
    if (
      this.state.thresholds &&
      Array.isArray(this.state.thresholds) &&
      this.state.thresholds.length > 0
    ) {
      window.addEventListener('scroll', this.handleGA4Scroll);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledGAonScroll);
  }

  handleGAOnScroll = () => {
    const prevTop = 0;
    let currentTop = 0;
    const doc = document.documentElement;
    const action = 'scroll_measure';
    currentTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (currentTop > prevTop) {
      for (let i = 0; i < this.scrollGAElements.length; i += 1) {
        if (
          this.scrollGAElements[i] &&
          this.isElementEdgesVisible(this.scrollGAElements[i], true)
        ) {
          analyticsWrapper(
            'grx',
            'send',
            'event',
            window.categoryForGA,
            action,
            `Scroll_${this.scrollGAElements[i].getAttribute(
              'data-scrollga',
            )}Ends`,
            { nonInteraction: 1 },
          );

          this.scrollGAElements[i].removeAttribute('data-scrollga');
          this.scrollGAElements.splice(i, 1);
          break;
        }
      }
    }
  };

  isElementEdgesVisible = (el, skewFromBottom) => {
    if (el) {
      const rect = el.getBoundingClientRect();
      const { bottom } = rect;
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

      if (skewFromBottom) {
        return bottom <= windowHeight;
      }

      return bottom <= 0;
    }

    return false;
  };

  setScrollGA4State = (threshold, ga4label) => {
    this.setState(
      {
        thresholds: [
          ...this.state.thresholds.filter(item => item !== threshold),
          this.state.thresholds[this.state.thresholds.length - 1] + 750,
        ],
      },
      () => {
        if (ga4label) {
          analyticsWrapper('ga4', {
            event: 'user_scroll',
            type: 'scroll-depth',
            label:
              typeof ga4label === 'string'
                ? ga4label
                : `scroll_${threshold / 750}`,
          });
        }
      },
    );
  };

  handleGA4Scroll = () => {
    // Get the current scroll position
    const scrollPosition = window.scrollY || window.pageYOffset;
    const thresholdsState = this.state.thresholds;
    thresholdsState.forEach(threshold => {
      if (scrollPosition >= threshold) {
        switch (threshold) {
          case 10:
            this.setScrollGA4State(threshold, 'scroll_starts');
            break;
          case 750:
            this.setScrollGA4State(threshold, 'scroll_1');
            break;
          case 1500:
            this.setScrollGA4State(threshold, 'scroll_2');
            break;
          case 2250:
            this.setScrollGA4State(threshold, 'scroll_3');
            break;
          case this.state.thresholds[0]:
            this.setScrollGA4State(this.state.thresholds[0], 1);
            break;
          default:
            break;
        }
      }
    });
  };
  render() {
    const { hpData, isHomePage, isPrime, topSearches } = this.props;
    const breadCrumbData =
      this.props.navigation && this.props.navigation.breadcrumbs
        ? this.props.navigation.breadcrumbs
        : [];
    const showTopSearches = !!(
      Array.isArray(topSearches?.items) && topSearches?.items?.length > 0
    );
    let adIndex = 0;
    return (
      <>
        <div
          className={s.pageWrap}
          data-translate-id="cw"
          data-translate-page="1"
        >
          {!isHomePage &&
            breadCrumbData && (
              <BreadCrumb data={breadCrumbData} wrapperClass="breadcrumb" />
            )}
          {showTopSearches && (
            <div>
              <TrendingSlider
                topSearches={topSearches?.items}
                title={topSearches?.name}
              />
            </div>
          )}
          {hpData?.sections &&
            Array.isArray(hpData.sections) &&
            hpData.sections.length > 0 &&
            // eslint-disable-next-line consistent-return, array-callback-return
            hpData.sections.map((section, index) => {
              switch (section.tn) {
                case 'type_1_layout':
                  if (
                    section.items &&
                    Array.isArray(section.items) &&
                    section.items.length > 0
                  ) {
                    return (
                      <InViewObserver
                        inViewCallback={() => {
                          if (section.ga4Type) {
                            analyticsWrapper('ga4', {
                              event: 'user_shown',
                              type: `${section.ga4Type}`,
                            });
                          }
                        }}
                      >
                        <CoverLayout
                          item={section}
                          index={index}
                          isPrime={isPrime}
                          s={s}
                        />
                      </InViewObserver>
                    );
                  }
                  break;
                case 'list_view':
                  if (
                    section.items &&
                    Array.isArray(section.items) &&
                    section.items.length > 0
                  ) {
                    return (
                      <InViewObserver
                        inViewCallback={() => {
                          if (section.ga4Type) {
                            analyticsWrapper('ga4', {
                              event: 'user_shown',
                              type: `${section.ga4Type}`,
                            });
                          }
                        }}
                      >
                        <ListView item={section} index={index} s={s} />
                      </InViewObserver>
                    );
                  }
                  break;
                case 'banner_view':
                  if (
                    section.items &&
                    Array.isArray(section.items) &&
                    section.items.length > 0
                  ) {
                    return (
                      <InViewObserver
                        inViewCallback={() => {
                          if (section.ga4Type) {
                            analyticsWrapper('ga4', {
                              event: 'user_shown',
                              type: `${section.ga4Type}`,
                            });
                          }
                        }}
                      >
                        <div
                          ref={this.bannerViewRef}
                          className={`${s.stickyBannerWrap} stickyBannerWrap `}
                          style={{ opacity: this.state.bannerOpacity }}
                        >
                          <div className={s.sbwInner}>
                            <BannerView item={section} index={index} s={s} />
                          </div>
                        </div>
                      </InViewObserver>
                    );
                  }
                  break;
                case 'seo_widget':
                  if (
                    section.items &&
                    Array.isArray(section.items) &&
                    section.items.length > 0
                  ) {
                    return (
                      <InViewObserver
                        inViewCallback={() => {
                          if (section.ga4Type) {
                            analyticsWrapper('ga4', {
                              event: 'user_shown',
                              type: `${section.ga4Type}`,
                            });
                          }
                        }}
                      >
                        <div className={s.secWrap}>
                          <div className={s.secWrapWs}>
                            <div className={s.ftLogoWrap} />
                            <div className={s.footerTop}>
                              <SeoWidget item={section} index={index} />
                            </div>
                          </div>
                        </div>
                      </InViewObserver>
                    );
                  }
                  break;
                case 'more_stories':
                  return (
                    <InViewObserver
                      inViewCallback={() => {
                        if (section.ga4Type) {
                          analyticsWrapper('ga4', {
                            event: 'user_shown',
                            type: `${section.ga4Type}`,
                          });
                        }
                      }}
                    >
                      <EtimesMoreStories item={section} index={index} />
                    </InViewObserver>
                  );
                case 'keywords':
                  return (
                    <div
                      className={
                        this.props.isCityHP ? s.trending_wrapper_main : ''
                      }
                    >
                      <TrendingSlider
                        topSearches={section.items}
                        title={section?.name}
                        ga4Type={section?.ga4Type}
                      />
                    </div>
                  );
                case 'ad':
                  if (!isPrime) {
                    const adname = `mid${adIndex || ''}`;
                    adIndex += 1;
                    section.name = adname;
                    section.groupName = 'midAds';
                  }
                  return (
                    !isPrime && (
                      <RenderAds
                        adObject={section}
                        key={`${section.tn}_${index}`}
                        isWapView={false}
                        immediateLoad={false}
                        lazyload={false}
                        wrapperClass={`${s.secWrap} phShimmer`}
                        campaigns={this.props.campaigns}
                      />
                    )
                  );
                default:
                  return null;
              }
            })}
        </div>
      </>
    );
  }
}

export default VideosListing;

VideosListing.contextTypes = {
  store: PropTypes.object.isRequired,
};
